// MODIFIED
import React, { useRef, useState } from "react";
import { SearchBar } from "../../../../common/APICommon";
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ExcelJS from "exceljs";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { saveAs } from "file-saver";
import LeaveIncentiveTable from "./components/LeaveIncentiveTable";
import { ConfirmationModal } from "../../../../common/Modal";
import { useFilterManager } from "../../../hooks/useFilterManager";
import { FEATURES } from "../../../../config/features";
import { DynamicFilterBar } from "../../filters/DynamicFilterBar";
import { buildMasterlistWorksheet } from "../../../../utils/employee/buildWorksheet";
import { RevertLeaveIncentiveForm } from "./components/RevertLeaveIncentiveForm";
import { useSimulateLoading } from "../../../hooks/useSimulateLoading";
import { ProcessLeaveIncentiveForm } from "./components/ProcessLeaveIncentiveForm";
import { CustomLoader } from "../Payroll/utils/CustomLoader";
import { LoadingSpinner } from "../../../../common/Loading";
import { useLeaveIncentive } from "../../../hooks/useLeaveIncentive";
import LeaveIncentiveViewModal from "./components/LeaveIncentiveViewModal";

const LeaveIncentiveModule = ({
  user,
  showGeneralMessage
}) => {
  const [showSettings, setShowSettings] = useState(false);
  const settingRef = useRef(null);

  // Modal States
  const [selectedItem, setSelectedItem] = useState(null);
  const [showProcessLeaveIncentiveForm, setShowProcessLeaveIncentiveForm] = useState(false);
  const [showRevertLeaveIncentiveForm, setShowRevertLeaveIncentiveForm] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);

  // ADDED: Pagination State (Matching LeaveTypeModule pattern)
  const [currentPage, setCurrentPage] = useState(1);

  // Confirmation Dialog State
  const [confirmConfig, setConfirmConfig] = useState({
    open: false,
    title: "",
    msg: "",
    action: null
  });

  const {
    activeFilterState,
    onFilterChange,
    apiFilterPayload,
    additionalApiFilterPayload,
    applyFilters,
    resetFilters
  } = useFilterManager(FEATURES.LEAVE_INCENTIVE_FILTERS || []);

  const {
    progress,
    loadingPercentage,
    setLoadingPercentage,
    longLoadingRequest,
    setLongLoadingRequest,
    simulateLoading,
    stopSimulation
  } = useSimulateLoading();

  const {
    data,
    employeeDetails,
    loading,
    refresh,
    fetchEmployeePreview,
    clearEmployeeDetails,
    processLeaveIncentive,
    revertLeaveIncentive,
    releaseIncentive
  } = useLeaveIncentive({
    user,
    apiFilterPayload,
    additionalApiFilterPayload,
    showGeneralMessage
  });

  const handleSearch = (value) => {
    // MODIFIED: Reset to page 1 on search like LeaveTypeModule
    setCurrentPage(1);
    // Note: searchData logic would go here if implemented in the hook
  };

  const handleRelease = (item) => {
    triggerConfirm(
      "Confirm Release",
      `Are you sure you want to release all pending incentives for ${item.employeeFullName}? This will mark all records as Completed.`,
      () => releaseIncentive(item.employeePersonalInformationId)
    );
  };


  const handleOpenEmployeeDetailsView = (item) => {
    fetchEmployeePreview(item.employeePersonalInformationId);
    setShowViewModal(true);
  };

  const handlecloseEmployeeDetailsView = () => {
    clearEmployeeDetails();
    setShowViewModal(false);
  };

  const openProcessLeaveIncentiveForm = () => {
    setShowProcessLeaveIncentiveForm(true);
  }
  const closeProcessLeaveIncentiveForm = () => {
    setShowProcessLeaveIncentiveForm(false);
  }

  const openRevertLeaveIncentiveForm = () => {
    setShowRevertLeaveIncentiveForm(true);
  }
  const closeRevertLeaveIncentiveForm = () => {
    setShowRevertLeaveIncentiveForm(false);
  }

  const triggerConfirm = (title, msg, action) => {
    setConfirmConfig({ open: true, title, msg, action });
  }
  return (
    <>
      <div className="relative">
        <div className="w-full py-2 px-4 box-border">
          <div className="text-sm">
            <span className="text-gray-400">{"Transaction > "}</span>
            <span className="border-b border-black text-gray-700">{"Leave Encashment"}</span>
          </div>
          <div className="flex items-center justify-between border-b bg-white">
            <h3 className="text-xl font-bold m-0 text-customMainColor tracking-tight uppercase">
              Leave Incentive
            </h3>
            <div className="flex items-center gap-3">
              <div className="relative flex items-center" ref={settingRef}>
                <button onClick={() => setShowSettings(!showSettings)} className="flex items-center gap-1 bg-blue-800 p-2 rounded hover:bg-blue-900 border-none cursor-pointer shadow-sm transition-all">
                  <SettingsIcon className="text-white" fontSize="small" />
                  <KeyboardArrowDownIcon className="text-white" fontSize="small" />
                </button>
                {showSettings && (
                  <div className="absolute right-0 top-full mt-2 w-52 bg-white shadow-2xl border border-gray-200 rounded-lg z-50 overflow-hidden animate-in fade-in zoom-in duration-100">
                    {/* <button
                      onClick={handleExport}
                      className="w-full flex items-center justify-start gap-2 px-4 py-3 text-left hover:bg-blue-50 border-none bg-transparent cursor-pointer text-gray-700 transition-colors"
                    >
                      <FileDownloadIcon fontSize="small" className="text-blue-600 shrink-0" />
                      <span className="text-sm font-medium">Export Summary to Excel</span>
                    </button> */}

                    <button
                      onClick={openProcessLeaveIncentiveForm}
                      className="w-full flex items-center justify-start gap-2 px-4 py-3 text-left hover:bg-blue-50 border-none bg-transparent cursor-pointer text-gray-700 transition-colors"
                    >
                      <AccountTreeIcon fontSize="small" className="text-amber-500 shrink-0" />
                      <span className="text-sm font-medium">Process Incentive</span>
                    </button>

                    <button
                      onClick={openRevertLeaveIncentiveForm}
                      className="w-full flex items-center justify-start gap-2 px-4 py-3 text-left hover:bg-blue-50 border-none bg-transparent cursor-pointer text-gray-700 transition-colors"
                    >
                      <SettingsBackupRestoreIcon fontSize="small" className="text-red-500 shrink-0" />
                      <span className="text-sm font-medium">Revert Incentive</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="p-4 space-y-4 relative">

          <div className="bg-white rounded-lg border border-gray-200 p-5 shadow-sm" style={{ border: "1px solid #d7d7d7" }}>
            <span className="text-lg font-semibold text-gray-600 block mb-4">Filters</span>

            <DynamicFilterBar
              requestedFilters={FEATURES.LEAVE_INCENTIVE_FILTERS || []}
              activeFilterState={activeFilterState}
              onFilterChange={onFilterChange}
              onApply={applyFilters}
              onClear={resetFilters}
              allowAll={true}
              showButtons={true}
            />
          </div>

          <div className="flex justify-between items-center">
            <SearchBar handleFilter={handleSearch} />
          </div>

          {/* MODIFIED: Passing currentPage and setCurrentPage to the table */}
          <LeaveIncentiveTable
            data={data}
            loading={loading}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            onRelease={handleRelease}
            onView={handleOpenEmployeeDetailsView}
          />

        </div>
      </div>

      <LeaveIncentiveViewModal
        isOpen={showViewModal}
        onClose={handlecloseEmployeeDetailsView}
        data={employeeDetails}
        loading={loading}
      />

      <ProcessLeaveIncentiveForm
        isOpen={showProcessLeaveIncentiveForm}
        onClose={closeProcessLeaveIncentiveForm}
        progress={progress}
        simulateLoading={simulateLoading}
        stopSimulation={stopSimulation}
        setLoadingPercentage={setLoadingPercentage}
        setLongLoadingRequest={setLongLoadingRequest}
        refresh={refresh}
        showGeneralMessage={showGeneralMessage}
        processLeaveIncentive={processLeaveIncentive}
        triggerConfirm={triggerConfirm}
      />

      <RevertLeaveIncentiveForm
        isOpen={showRevertLeaveIncentiveForm}
        onClose={closeRevertLeaveIncentiveForm}
        progress={progress}
        simulateLoading={simulateLoading}
        stopSimulation={stopSimulation}
        setLoadingPercentage={setLoadingPercentage}
        setLongLoadingRequest={setLongLoadingRequest}
        refresh={refresh}
        showGeneralMessage={showGeneralMessage}
        revertLeaveIncentive={revertLeaveIncentive}
        triggerConfirm={triggerConfirm}
      />

      <ConfirmationModal
        visible={confirmConfig.open}
        title={confirmConfig.title}
        message={confirmConfig.msg}
        onConfirm={async () => {
          const actionToExecute = confirmConfig.action;
          setConfirmConfig((prev) => ({ ...prev, open: false }));
          if (actionToExecute) {
            await actionToExecute();
          }
        }}
        onClose={() => setConfirmConfig({ ...confirmConfig, open: false })}
      />

      <LoadingSpinner loading={loading} />
      {longLoadingRequest ? (<CustomLoader loadingPercentage={loadingPercentage} />) : (<></>)}
    </>
  );
};

export default LeaveIncentiveModule;